import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmationDialog, ConfirmationDialogDefinition} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.types';
import {ConfirmationDialogComponent} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.component';
import {CheckoutDialogData} from '@store/checkouts/checkouts.types';
import {CheckoutDetailComponent} from '@app/my-account/checked-out/detail/checkout-detail.component';

@Component({
  selector: 'px-renew-item-dialog',
  template: `
    <mx-confirmation-dialog [definition]="dialogDefinition">
      <px-checkout-detail [checkout]="checkout"/>
    </mx-confirmation-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConfirmationDialogComponent, CheckoutDetailComponent]
})
export class RenewItemDialog implements ConfirmationDialog<CheckoutDialogData> {
  public readonly dialogData: CheckoutDialogData = inject(MAT_DIALOG_DATA);
  public readonly checkout = this.dialogData.checkout;

  public readonly dialogDefinition: ConfirmationDialogDefinition = {
    title: 'Renew Item',
    confirmButtonLabel: 'Renew'
  };
}
